"use client";
import { useEffect, useState } from "react";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { LayoutProps } from "@/components/layout/layoutType";
import Icon from "@/components/common/icon/sicon";
import { koLocale } from "@/i18n/routing";
//import dynamic from "next/dynamic";
//const SIcon = dynamic(() => import("@/components/common/icon/sicon"), { ssr: false });

export default function PrivacyPolicy({ params }: { params?: LayoutProps }) {
  const t = useTranslations("alert");
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Container className="PrivatePolicy max-w-full">
      <Skeleton loading={loading}>
        {params?.locale === koLocale ? (
          <>
            <h1>Coffee Insite 개인정보 처리방침</h1>
            <section>
              <p>
                <strong>Coffee Insite</strong> 앱 및 웹사이트는 광고 기반 서비스로 제공됩니다. 사용자가 서비스를 이용할 때 발생하는
                개인정보 수집, 사용, 공유에 대해 안내드립니다.
              </p>
              <p>본 서비스를 사용하거나 웹사이트를 이용함으로써, 사용자는 본 개인정보 처리방침에 동의하게 됩니다.</p>
            </section>

            <h2>1. 수집하는 개인정보</h2>
            <section>
              <p>서비스 제공 및 개선을 위해 다음과 같은 정보가 수집될 수 있습니다:</p>
              <ul>
                <li>
                  <strong>기본 식별 정보</strong>: 광고 ID, 기기 정보, OS 버전 등
                </li>
                <li>
                  <strong>로그 데이터</strong>: 오류, 사용 시간, 앱 설정, IP 주소 등 통계 정보
                </li>
                <li>
                  <strong>쿠키 및 유사 기술</strong>: 웹사이트 방문 기록, 광고 및 분석 목적
                </li>
              </ul>
              <p>
                ※ 앱에서 요청하는 정보는 <strong>사용자 기기에 저장되며, 직접 수집하지 않습니다.</strong>
              </p>
            </section>

            <h2>2. 제3자 서비스</h2>
            <section>
              <p>앱과 웹사이트는 광고, 분석, 통계 목적으로 다음 제3자 서비스를 사용합니다:</p>
              <ul>
                <li>
                  Google Play Services –{" "}
                  <a href="https://policies.google.com/privacy" target="_blank">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  AdMob –{" "}
                  <a href="https://policies.google.com/technologies/ads" target="_blank">
                    Ads and Privacy Policy
                  </a>
                </li>
                {/* <li>
                  Firebase Analytics –{" "}
                  <a href="https://firebase.google.com/policies/analytics" target="_blank">
                    Privacy Policy
                  </a>
                </li> */}
              </ul>
              <p>
                이 제3자들은 서비스를 수행하기 위해 개인정보에 접근할 수 있으나, 다른 목적으로 사용하거나 공개하지 않을 의무가 있습니다.
              </p>
            </section>

            <h2>3. 쿠키(Cookies)</h2>
            <section>
              <p>웹사이트에서는 쿠키 및 유사 기술을 사용하여 사용자 경험과 서비스 품질을 향상시킵니다.</p>
              <ul>
                <li>사용자는 쿠키 수신을 거부할 수 있으며, 거부 시 일부 기능 사용에 제한이 있을 수 있습니다.</li>
                <li>앱 자체에서는 쿠키를 직접 사용하지 않지만, 제3자 SDK를 통해 간접적으로 수집될 수 있습니다.</li>
              </ul>
            </section>

            <h2>4. 보안</h2>
            <section>
              <p>
                개인정보 보호를 위해 상업적으로 합리적인 조치를 사용하고 있습니다. 그러나 인터넷 전송이나 전자 저장 방식은 100% 안전하지
                않으므로, 절대적 보안을 보장할 수 없습니다.
              </p>
            </section>

            <h2>5. 외부 링크</h2>
            <section>
              <p>
                앱 및 웹사이트에는 외부 링크가 포함될 수 있습니다. 외부 사이트는 본 서비스와 관련이 없으며, 콘텐츠 및 개인정보 처리방침에
                대해 책임을 지지 않습니다.
              </p>
            </section>

            <h2>6. 아동 개인정보 보호</h2>
            <section>
              <ul>
                <li>본 서비스는 만 13세 미만 아동을 대상으로 하지 않습니다.</li>
                <li>13세 미만 아동으로부터 개인정보를 수집하지 않습니다.</li>
                <li>발견 시 즉시 삭제하며, 부모/보호자는 삭제 요청이 가능합니다.</li>
              </ul>
            </section>

            <h2>7. 개인정보 처리방침 변경</h2>
            <section>
              <p>정책은 수시로 업데이트되며, 변경 시 본 페이지에 즉시 게시됩니다. 주기적으로 확인하시기 바랍니다.</p>
            </section>

            <h2>8. 문의처</h2>
            <section>
              <p>개인정보 처리방침 관련 문의는 아래 이메일로 연락해 주세요.</p>
              <p>
                <strong>
                  <a href="mailto:developerlhsm2@gmail.com">developerlhsm2@gmail.com</a>
                </strong>
              </p>
            </section>
          </>
        ) : (
          <>
            <h1>Coffee Insite Privacy Policy</h1>

            <section>
              <p>
                The <strong>Coffee Insite</strong> app and website are ad-supported services. This Privacy Policy explains how we collect,
                use, and share your personal information.
              </p>
              <p>By using our app or website, you agree to the terms of this Privacy Policy.</p>
            </section>

            <h2>1. Information We Collect</h2>
            <section>
              <ul>
                <li>
                  <strong>Basic Identifiers</strong>: Advertising ID, device information, OS version, etc.
                </li>
                <li>
                  <strong>Log Data</strong>: Errors, usage time, app settings, IP address, and other statistics
                </li>
                <li>
                  <strong>Cookies and Similar Technologies</strong>: Website visit records, advertising, and analytics purposes
                </li>
              </ul>
              <p>
                Note: Information requested by the app is <strong>stored on your device and not directly collected by us.</strong>
              </p>
            </section>

            <h2>2. Third-Party Services</h2>
            <section>
              <ul>
                <li>
                  Google Play Services –{" "}
                  <a href="https://policies.google.com/privacy" target="_blank">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  AdMob –{" "}
                  <a href="https://policies.google.com/technologies/ads" target="_blank">
                    Ads and Privacy Policy
                  </a>
                </li>
                {/* <li>
                  Firebase Analytics –{" "}
                  <a href="https://firebase.google.com/policies/analytics" target="_blank">
                    Privacy Policy
                  </a>
                </li> */}
              </ul>
              <p>
                These third parties may access your personal information to perform their services but are{" "}
                <strong>obliged not to use it for other purposes.</strong>
              </p>
            </section>

            <h2>3. Cookies</h2>
            <section>
              <ul>
                <li>The website uses cookies and similar technologies to improve user experience and service performance.</li>
                <li>Users may refuse cookies, but some features may be limited.</li>
                <li>The app does not use cookies directly, but third-party SDKs may collect information indirectly.</li>
              </ul>
            </section>

            <h2>4. Security</h2>
            <section>
              <p>
                We take commercially reasonable measures to protect your personal information. However, no method of transmission over the
                Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <h2>5. Links to Other Sites</h2>
            <section>
              <p>
                Our app or website may contain links to third-party sites. These sites are <strong>not operated by us</strong>, and we are
                not responsible for their privacy policies or content.
              </p>
            </section>

            <h2>6. Children’s Privacy</h2>
            <section>
              <ul>
                <li>
                  Our services are <strong>not intended for children under 13</strong>.
                </li>
                <li>We do not knowingly collect personal information from children under 13.</li>
                <li>
                  If a child under 13 provides information, it will be deleted immediately. Parents or guardians may request deletion.
                </li>
              </ul>
            </section>

            <h2>7. Changes to This Privacy Policy</h2>
            <section>
              <p>
                This Privacy Policy may be updated from time to time and takes effect immediately when posted. We recommend reviewing this
                page periodically.
              </p>
            </section>

            <h2>8. Contact Us</h2>
            <section>
              <p>For questions regarding this Privacy Policy, please contact us at:</p>
              <p>
                <strong>
                  <a href="mailto:developerlhsm2@gmail.com">developerlhsm2@gmail.com</a>
                </strong>
              </p>
            </section>
          </>
        )}
      </Skeleton>
    </Container>
  );
}
